/* ============================================================
   recipe.js  —  Interaktivitaet fuer Rezepte
   - Uebersicht: Kategorie-Filter + Live-Suche
   - Detail: Portionsrechner, Kochmodus (Wake Lock), Drucken
   Laeuft in beiden Sections; per Guard nur einmal initialisiert.
   ============================================================ */
(function () {
  if (window.__recipeInit) return;
  window.__recipeInit = true;

  /* ---------- Hilfen fuer Zahlen ---------- */
  // Unicode-Brueche (½, ¼, …) -> Dezimalwert
  var VULGAR = { '½':0.5,'⅓':1/3,'⅔':2/3,'¼':0.25,'¾':0.75,'⅕':0.2,'⅖':0.4,'⅗':0.6,'⅘':0.8,'⅙':1/6,'⅚':5/6,'⅛':0.125,'⅜':0.375,'⅝':0.625,'⅞':0.875 };
  var VF = '½⅓⅔¼¾⅕⅖⅗⅘⅙⅚⅛⅜⅝⅞';
  // Alle Mengen-Schreibweisen (Reihenfolge: laengste zuerst):
  //  gemischt Bruch "1 1/2", Bruch "1/2", gemischt Unicode "1½", Unicode "½", Dezimal/Ganz "1,5"
  var NUM = '(?:\\d+\\s+\\d+\\s*\\/\\s*\\d+|\\d+\\s*\\/\\s*\\d+|\\d+\\s*[' + VF + ']|[' + VF + ']|\\d+(?:[.,]\\d+)?)';

  function parseNum(s) {
    s = String(s).trim();
    if (s.length === 1 && VULGAR[s] != null) return VULGAR[s];
    var mv = s.match(new RegExp('^(\\d+)\\s*([' + VF + '])$'));       // "1½"
    if (mv) return parseInt(mv[1], 10) + VULGAR[mv[2]];
    var ms = s.match(/^(\d+)\s+(\d+)\s*\/\s*(\d+)$/);                  // "1 1/2"
    if (ms) return (+ms[1]) + (+ms[2]) / (+ms[3]);
    if (s.indexOf('/') !== -1) { var p = s.split('/'); return parseFloat(p[0].replace(',', '.')) / parseFloat(p[1].replace(',', '.')); }
    return parseFloat(s.replace(',', '.'));
  }
  function fmtNum(n) {
    if (!isFinite(n)) return '';
    var r = Math.round(n * 100) / 100;
    var str = Number.isInteger(r) ? String(r) : r.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
    return str.replace('.', ',');
  }
  // Skaliert die fuehrende Menge (Zahl/Bruch/Bereich) am Anfang eines Strings.
  function scaleLeading(text, factor) {
    var range = text.match(new RegExp('^(\\s*)(' + NUM + ')\\s*([-–])\\s*(' + NUM + ')'));
    if (range) {
      var a = fmtNum(parseNum(range[2]) * factor);
      var b = fmtNum(parseNum(range[4]) * factor);
      return text.replace(range[0], range[1] + a + range[3] + b);
    }
    var m = text.match(new RegExp('^(\\s*)(' + NUM + ')'));
    if (m) {
      var val = fmtNum(parseNum(m[2]) * factor);
      return text.replace(m[0], m[1] + val);
    }
    return text; // keine Zahl am Anfang (z. B. "Salz nach Geschmack")
  }

  /* ---------- Portionsrechner ---------- */
  function initServings() {
    var control = document.querySelector('[data-servings-control]');
    var list = document.querySelector('.recipe__ingredients');
    if (!control || !list) return;

    var base = parseInt(list.getAttribute('data-base-servings'), 10) || 0;
    if (base <= 0) return;

    var current = base;
    var valueEl = control.querySelector('[data-servings-value]');
    // Neu (getrennte Felder): nur das Mengen-Element skalieren.
    var amountEls = Array.prototype.slice.call(list.querySelectorAll('[data-amount]'));
    amountEls.forEach(function (el) { el.setAttribute('data-orig', el.getAttribute('data-amount') || el.textContent); });
    // Fallback (altes Einzelfeld): fuehrende Menge in der ganzen Zeile skalieren.
    var legacyEls = Array.prototype.slice.call(list.querySelectorAll('[data-ingredient-text]'));
    legacyEls.forEach(function (el) { el.setAttribute('data-orig', el.textContent); });

    function render() {
      var factor = current / base;
      amountEls.forEach(function (el) {
        el.textContent = factor === 1 ? el.getAttribute('data-orig') : scaleLeading(el.getAttribute('data-orig'), factor);
      });
      legacyEls.forEach(function (el) {
        el.textContent = factor === 1 ? el.getAttribute('data-orig') : scaleLeading(el.getAttribute('data-orig'), factor);
      });
      if (valueEl) valueEl.textContent = current;
    }

    var dec = control.querySelector('[data-servings-dec]');
    var inc = control.querySelector('[data-servings-inc]');
    if (dec) dec.addEventListener('click', function () { if (current > 1) { current--; render(); } });
    if (inc) inc.addEventListener('click', function () { current++; render(); });
  }

  /* ---------- Kochmodus (Bildschirm anlassen) ---------- */
  function initCookMode() {
    var input = document.querySelector('[data-cookmode]');
    if (!input) return;
    var wakeLock = null;

    async function request() {
      try { if ('wakeLock' in navigator) wakeLock = await navigator.wakeLock.request('screen'); }
      catch (e) { /* nicht unterstuetzt – Modus funktioniert optisch trotzdem */ }
    }
    input.addEventListener('change', function () {
      var on = input.checked;
      document.body.classList.toggle('recipe-cookmode-on', on);
      if (on) { request(); }
      else if (wakeLock) { wakeLock.release(); wakeLock = null; }
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && document.body.classList.contains('recipe-cookmode-on')) request();
    });
  }

  /* ---------- Drucken ---------- */
  function initPrint() {
    var btn = document.querySelector('[data-print]');
    if (btn) btn.addEventListener('click', function () { window.print(); });
  }

  /* ---------- In den Warenkorb (nativ wie auf der Produktseite) ----------
     Fuegt per AJAX hinzu und benachrichtigt Focals Warenkorb ueber die
     gleichen Events wie das Theme selbst:
       - cart:updated  -> aktualisiert den Zaehler im Header
       - cart:refresh  -> rendert den Mini-Warenkorb neu und oeffnet den Drawer
     Beide werden auf document.documentElement ausgeloest (dort hoert Focal).
  */
  function refreshFocalCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var root = document.documentElement;
        root.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        root.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, openMiniCart: true } }));
      });
  }

  // Ladespinner (gleicher SVG-Kreis wie Focals loader-button).
  var SPINNER_HTML =
    '<span class="recipe__btn-spinner" aria-hidden="true">' +
      '<svg viewBox="25 25 50 50" width="20" height="20">' +
        '<circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>' +
      '</svg>' +
    '</span>';

  // Kleines Konfetti aus der Button-Mitte.
  function burstConfetti(button) {
    if (!button) return;
    var rect = button.getBoundingClientRect();
    var originX = rect.left + rect.width / 2;
    var originY = rect.top + rect.height / 2;
    var colors = ['#F1CE7D', '#FA9DB7', '#EBBD51', '#A1DFFB', '#FFD6E8'];
    for (var i = 0; i < 25; i++) {
      var c = document.createElement('div');
      c.className = 'hz-confetti';
      c.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      c.style.left = originX + 'px';
      c.style.top = originY + 'px';
      c.style.setProperty('--x', ((Math.random() - 0.5) * 200) + 'px');
      c.style.setProperty('--y', ((Math.random() - 1) * 150) + 'px');
      document.body.appendChild(c);
      (function (el) { setTimeout(function () { el.remove(); }, 1000); })(c);
    }
  }

  /* ---------- Teilen (nativ auf Mobile, Menue als Fallback) ---------- */
  function initShare() {
    var trigger = document.querySelector('[data-share]');
    if (!trigger) return;
    var wrap = trigger.parentNode;
    var url = trigger.getAttribute('data-share-url') || location.href;
    var title = trigger.getAttribute('data-share-title') || document.title;
    var image = trigger.getAttribute('data-share-image') || '';
    var eu = encodeURIComponent(url), et = encodeURIComponent(title), ei = encodeURIComponent(image);

    function svg(p) {
      return '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true"><path d="' + p + '"/></svg>';
    }

    var targets = [
      { label: 'WhatsApp', color: '#25D366',
        href: 'https://wa.me/?text=' + encodeURIComponent(title + ' ' + url),
        icon: svg('M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.16-.17.2-.35.22-.64.08-.3-.15-1.26-.47-2.39-1.48-.88-.79-1.48-1.76-1.66-2.06-.17-.3-.02-.46.13-.6.13-.14.3-.35.44-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.6-.92-2.2-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.69.62.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2-1.41.25-.7.25-1.29.18-1.41-.08-.13-.27-.2-.57-.35M12.05 21.8h-.01a9.87 9.87 0 01-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 01-1.51-5.26c0-5.45 4.44-9.88 9.9-9.88 2.64 0 5.12 1.03 6.99 2.9a9.82 9.82 0 012.89 6.99c0 5.45-4.44 9.88-9.89 9.88M20.46 3.49A11.82 11.82 0 0012.05 0C5.5 0 .16 5.34.16 11.9c0 2.1.55 4.14 1.59 5.95L.06 24l6.3-1.65a11.88 11.88 0 005.68 1.45h.01c6.55 0 11.89-5.34 11.89-11.9 0-3.18-1.24-6.17-3.48-8.41z') },
      { label: 'Facebook', color: '#1877F2',
        href: 'https://www.facebook.com/sharer/sharer.php?u=' + eu,
        icon: svg('M24 12.07C24 5.44 18.63.07 12 .07S0 5.44 0 12.07c0 5.99 4.39 10.95 10.13 11.85v-8.38H7.08v-3.47h3.05V9.43c0-3.01 1.79-4.67 4.53-4.67 1.31 0 2.69.24 2.69.24v2.95h-1.51c-1.49 0-1.96.93-1.96 1.87v2.25h3.33l-.53 3.47h-2.8v8.38C19.61 23.02 24 18.06 24 12.07z') },
      { label: 'Pinterest', color: '#E60023',
        href: 'https://pinterest.com/pin/create/button/?url=' + eu + '&media=' + ei + '&description=' + et,
        icon: svg('M12.02 0C5.4 0 .03 5.37.03 11.99c0 5.08 3.16 9.42 7.62 11.16-.11-.95-.2-2.4.04-3.44.22-.94 1.41-5.96 1.41-5.96s-.36-.72-.36-1.78c0-1.66.97-2.91 2.17-2.91 1.02 0 1.52.77 1.52 1.69 0 1.03-.65 2.57-.99 3.99-.29 1.2.6 2.17 1.77 2.17 2.13 0 3.77-2.25 3.77-5.49 0-2.86-2.06-4.87-5.01-4.87-3.41 0-5.41 2.56-5.41 5.2 0 1.03.4 2.14.89 2.74.1.12.11.23.08.35-.09.37-.29 1.2-.33 1.36-.05.22-.17.27-.4.16-1.5-.69-2.43-2.88-2.43-4.65 0-3.78 2.75-7.25 7.92-7.25 4.16 0 7.39 2.97 7.39 6.92 0 4.14-2.61 7.46-6.23 7.46-1.21 0-2.35-.63-2.76-1.38l-.75 2.85c-.27 1.05-1 2.35-1.5 3.15 1.12.34 2.31.53 3.55.53 6.61 0 11.99-5.36 11.99-11.99C23.97 5.39 18.59.03 11.98.03z') },
      { label: 'X (Twitter)', color: '#111',
        href: 'https://twitter.com/intent/tweet?url=' + eu + '&text=' + et,
        icon: svg('M18.24 2.25h3.31l-7.23 8.26 8.5 11.24h-6.66l-5.21-6.82-5.97 6.82H1.68l7.73-8.84L1.25 2.25h6.83l4.71 6.23zm-1.16 17.52h1.83L7.08 4.13H5.12z') },
      { label: 'Per E-Mail', color: '#6b7280',
        href: 'mailto:?subject=' + et + '&body=' + encodeURIComponent(title + '\n' + url),
        icon: svg('M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.93 5.5a3 3 0 01-3.14 0zM22.5 6.91v-.16a3 3 0 00-3-3h-15a3 3 0 00-3 3v.16l9.71 5.97a1.5 1.5 0 001.58 0z') }
    ];

    var menu = document.createElement('div');
    menu.className = 'recipe__share-menu';
    menu.setAttribute('hidden', '');

    function item(html) {
      return '<span class="recipe__share-ico" style="color:' + html.color + '">' + html.icon + '</span><span>' + html.label + '</span>';
    }

    targets.forEach(function (t) {
      var a = document.createElement('a');
      a.className = 'recipe__share-item';
      a.href = t.href; a.target = '_blank'; a.rel = 'noopener noreferrer';
      a.innerHTML = item(t);
      a.addEventListener('click', function () { close(); });
      menu.appendChild(a);
    });

    var copy = document.createElement('button');
    copy.type = 'button';
    copy.className = 'recipe__share-item';
    copy.innerHTML = item({ color: '#6b7280', label: 'Link kopieren',
      icon: svg('M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7a5 5 0 000 10h4v-1.9H7A3.1 3.1 0 013.9 12zM8 13h8v-2H8zm9-6h-4v1.9h4a3.1 3.1 0 010 6.2h-4V17h4a5 5 0 000-10z') });
    copy.addEventListener('click', function () {
      var label = copy.querySelector('span:last-child');
      function done() { if (label) { label.textContent = 'Kopiert ✓'; setTimeout(function () { label.textContent = 'Link kopieren'; }, 1500); } }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done).catch(done);
      else done();
    });
    menu.appendChild(copy);
    wrap.appendChild(menu);

    function onDoc(e) { if (!menu.contains(e.target) && !trigger.contains(e.target)) close(); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    function open() {
      menu.removeAttribute('hidden');
      trigger.setAttribute('aria-expanded', 'true');
      setTimeout(function () { document.addEventListener('click', onDoc); document.addEventListener('keydown', onKey); }, 0);
    }
    function close() {
      menu.setAttribute('hidden', '');
      trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', onDoc);
      document.removeEventListener('keydown', onKey);
    }

    trigger.addEventListener('click', function () {
      if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
      if (menu.hasAttribute('hidden')) open(); else close();
    });
  }

  // Nutzt Focals Standard-Fehlermeldung (rote Leiste unter dem Header).
  function showCartError(msg) {
    document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show', {
      bubbles: true,
      cancelable: true,
      detail: { status: 'error', error: msg || 'Das Produkt konnte nicht in den Warenkorb gelegt werden.' }
    }));
  }

  // Varianten-IDs aus dem Formular lesen (Einzel: id | Mehrfach: items[i][id]).
  function extractItems(form) {
    var fd = new FormData(form);
    if (fd.get('id')) return [{ id: fd.get('id'), quantity: fd.get('quantity') || 1 }];
    var items = [];
    fd.forEach(function (value, key) {
      var mi = /^items\[(\d+)\]\[id\]$/.exec(key);
      var mq = /^items\[(\d+)\]\[quantity\]$/.exec(key);
      if (mi) { items[+mi[1]] = items[+mi[1]] || {}; items[+mi[1]].id = value; }
      if (mq) { items[+mq[1]] = items[+mq[1]] || {}; items[+mq[1]].quantity = value; }
    });
    return items.filter(Boolean);
  }

  // Einen Artikel per AJAX hinzufuegen -> {ok, message}
  function addOne(it) {
    var body = new URLSearchParams();
    body.set('id', it.id);
    body.set('quantity', it.quantity || 1);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    })
    .then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        return { ok: res.ok, message: data.description || data.message || '' };
      });
    })
    .catch(function () { return { ok: false, message: '' }; });
  }

  function initAddToCart() {
    var root = document.querySelector('[data-recipe]');
    if (!root) return;
    var forms = Array.prototype.slice.call(root.querySelectorAll('form[action^="/cart/add"]'));
    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        var originalHTML = btn ? btn.innerHTML : '';

        burstConfetti(btn);

        if (btn) {
          btn.style.minWidth = btn.offsetWidth + 'px'; // Breite halten, kein Springen
          btn.disabled = true;
          btn.classList.add('is-loading');
          btn.innerHTML = SPINNER_HTML;
        }

        function restore() {
          if (!btn) return;
          btn.innerHTML = originalHTML;
          btn.style.minWidth = '';
          btn.disabled = false;
          btn.classList.remove('is-loading');
        }

        // Artikel nacheinander hinzufuegen -> nicht alles scheitert, wenn einer nicht geht.
        var items = extractItems(form);
        var added = 0, lastError = '';
        var chain = Promise.resolve();
        items.forEach(function (it) {
          chain = chain.then(function () {
            return addOne(it).then(function (r) {
              if (r.ok) added++; else lastError = r.message || lastError;
            });
          });
        });

        chain.then(function () {
          restore();
          if (added > 0) refreshFocalCart().catch(function () {}); // Warenkorb best effort
          if (added === 0) {
            showCartError(lastError); // gar nichts ging -> Meldung
          } else if (added < items.length) {
            // Teilerfolg: der Rest ist drin, nur einzelne nicht
            showCartError('Einige Zutaten konnten nicht hinzugefügt werden.' + (lastError ? ' ' + lastError : ''));
          }
        });
      });
    });
  }

  /* ---------- Uebersicht: Filter + Suche ---------- */
  function initList() {
    var root = document.querySelector('[data-recipe-list]');
    if (!root) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-recipe-card]'));
    var filterBtns = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
    var search = root.querySelector('[data-recipe-search]');
    var empty = root.querySelector('[data-recipe-empty]');
    var activeFilter = '*';

    function apply() {
      var term = search ? search.value.trim().toLowerCase() : '';
      var visible = 0;
      cards.forEach(function (card) {
        var cats = card.getAttribute('data-cats') || '';
        var title = card.getAttribute('data-title') || '';
        var matchCat = activeFilter === '*' || cats.split(' ').indexOf(activeFilter) !== -1;
        var matchTerm = !term || title.indexOf(term) !== -1;
        var show = matchCat && matchTerm;
        card.hidden = !show;
        if (show) visible++;
      });
      if (empty) empty.hidden = visible !== 0;
    }

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activeFilter = btn.getAttribute('data-filter');
        filterBtns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        apply();
      });
    });
    if (search) search.addEventListener('input', apply);
  }

  /* ---------- Carousel „Aehnliche Rezepte" / „Rezepte mit Produkt" (Pfeile + Punkte) ---------- */
  function initRelatedCarousel() {
    Array.prototype.slice.call(document.querySelectorAll('.recipe__related-carousel')).forEach(setupCarousel);
  }
  function setupCarousel(track) {
    var cards = Array.prototype.slice.call(track.querySelectorAll('.recipe-card'));
    if (cards.length < 2) return;

    function mkArrow(dir, glyph, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'recipe__caro-arrow recipe__caro-' + dir;
      b.setAttribute('aria-label', label);
      b.textContent = glyph;
      return b;
    }

    var wrap = document.createElement('div');
    wrap.className = 'recipe__caro';
    track.parentNode.insertBefore(wrap, track);
    var prev = mkArrow('prev', '‹', 'Vorherige Rezepte');
    var next = mkArrow('next', '›', 'Weitere Rezepte');
    wrap.appendChild(prev);
    wrap.appendChild(track);
    wrap.appendChild(next);

    var dots = document.createElement('div');
    dots.className = 'recipe__caro-dots';
    cards.forEach(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'recipe__caro-dot';
      d.setAttribute('aria-label', 'Zu Kachel ' + (i + 1));
      d.addEventListener('click', function () { go(i); });
      dots.appendChild(d);
    });
    wrap.parentNode.insertBefore(dots, wrap.nextSibling);

    function mobile() { return window.matchMedia('(max-width: 749px)').matches; }
    function stride() {
      return cards.length > 1
        ? (cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left)
        : cards[0].getBoundingClientRect().width;
    }
    function perView() { return Math.max(1, Math.round(track.clientWidth / stride())); }
    function activeIndex() {
      var t = track.getBoundingClientRect();
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].getBoundingClientRect().left >= t.left - 2) return i;
      }
      return cards.length - 1;
    }
    function go(i) {
      i = Math.max(0, Math.min(cards.length - 1, i));
      cards[i].scrollIntoView({ behavior: 'smooth', inline: mobile() ? 'center' : 'start', block: 'nearest' });
    }

    prev.addEventListener('click', function () { go(activeIndex() - perView()); });
    next.addEventListener('click', function () { go(activeIndex() + perView()); });

    function update() {
      var a = activeIndex();
      Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === a); });
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      var scrollable = track.scrollWidth - track.clientWidth > 4;
      wrap.classList.toggle('is-static', !scrollable);
      dots.classList.toggle('is-static', !scrollable);
    }
    var tmr;
    track.addEventListener('scroll', function () { clearTimeout(tmr); tmr = setTimeout(update, 80); });
    window.addEventListener('resize', function () { clearTimeout(tmr); tmr = setTimeout(update, 120); });
    update();
  }

  /* ---------- Punkte fuers Highlight-Widget (nur mobil, Karussell) ---------- */
  function initFeaturedDots() {
    var track = document.querySelector('.recipe-featured__grid');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll('.recipe-feat-card'));
    if (cards.length < 2) return;

    var dots = document.createElement('div');
    dots.className = 'recipe__caro-dots recipe-featured__dots';
    cards.forEach(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'recipe__caro-dot';
      d.setAttribute('aria-label', 'Zu Kachel ' + (i + 1));
      d.addEventListener('click', function () {
        cards[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
      dots.appendChild(d);
    });
    track.parentNode.insertBefore(dots, track.nextSibling);

    function activeIndex() {
      var t = track.getBoundingClientRect();
      var mid = t.left + t.width / 2, best = 0, bd = Infinity;
      cards.forEach(function (c, i) {
        var r = c.getBoundingClientRect();
        var d = Math.abs((r.left + r.width / 2) - mid);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }
    function update() {
      var a = activeIndex();
      Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === a); });
      // Auf Desktop ist das Grid nicht horizontal scrollbar -> Punkte ausblenden.
      var scrollable = track.scrollWidth - track.clientWidth > 4;
      dots.classList.toggle('is-static', !scrollable);
    }
    var tmr;
    track.addEventListener('scroll', function () { clearTimeout(tmr); tmr = setTimeout(update, 80); });
    window.addEventListener('resize', function () { clearTimeout(tmr); tmr = setTimeout(update, 120); });
    update();
  }

  function boot() {
    initServings();
    initCookMode();
    initPrint();
    initShare();
    initAddToCart();
    initRelatedCarousel();
    initFeaturedDots();
    initList();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
